import React from 'react'

function HeaderTitle({ title, description }) {
    return (
        <div className='row mt-3'>
            <div className='col-12'>
                <h5 className='text-body'>{title}</h5>
                <p className='text-muted'>{description} </p>
            </div>
        </div>
    )
}

export default HeaderTitle